// =============================================================================
// FILE: packages/renderer/src/config/manualPayment.ts
// PURPOSE: Single source of truth for the temporary manual-payment workflow —
//   the E-transfer notice copy + a flag that hides live PayPal buttons across
//   the app while every paid product routes through founder license approval.
// =============================================================================

export const MANUAL_PAYMENT_MODE = true;   // hides PayPal; routes to manual approval
export const PAYPAL_ENABLED = false;

export const ETRANSFER_EMAIL = 'john.bismonte@gmail.com';

export const MANUAL_PAYMENT_NOTICE =
  'Manual payment processing is currently enabled. To purchase this R2 design ' +
  `package, please send payment through E-transfer: ${ETRANSFER_EMAIL}. ` +
  'PayPal payment options are being prepared. After payment verification, your ' +
  'R2 license will be manually activated.';

export interface GeneratorProduct { id: string; name: string; category: string; price?: string; }

// R2 Generator Universe — sellable design packages (manual approval).
export const R2_GENERATORS: GeneratorProduct[] = [
  { id: 'rail-generator',        name: 'Rail Generator',              category: 'Transportation' },
  { id: 'hotel-generator',       name: 'Hotel Generator',             category: 'Building & Property' },
  { id: 'airport-generator',     name: 'Airport Generator',           category: 'Transportation' },
  { id: 'resort-beach-generator', name: 'Resort Beach Generator',     category: 'Tourism & Environment' },
  { id: 'mountain-camping-generator', name: 'Mountain Camping Generator', category: 'Tourism & Environment' },
  { id: 'business-plaza-generator', name: 'Business Plaza Generator',  category: 'Building & Property' },
  { id: 'retail-store-generator', name: 'Retail Store Generator',     category: 'Building & Property' },
  { id: 'green-city-generator',  name: 'Green City Generator',        category: 'City & Community' },
  { id: 'underground-city-generator', name: 'Underground City Generator', category: 'City & Community' },
  { id: 'mansion-generator',     name: 'Mansion Generator',           category: 'Building & Property' },
  { id: 'bunker-generator',      name: 'Bunker Generator',            category: 'Resilience' },
];
